"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientApp = void 0;
var ClientApp;
(function (ClientApp) {
    ClientApp["JOB_POSTING"] = "JOB_POSTING";
    ClientApp["UNKNOWN"] = "UNKNOWN";
})(ClientApp = exports.ClientApp || (exports.ClientApp = {}));
